import type { ProductCard } from "./ProductsTypes";

export const MAX_VISIBLE_CARDS_WITHOUT_SWIPER = 5;

export function getDesktopGridSize(productsLength: number) {
  return productsLength === MAX_VISIBLE_CARDS_WITHOUT_SWIPER ? 2 : 3;
}

export function hasPrice(product: ProductCard) {
  return Boolean(product.price && product.decimalPrice);
}

export function hasOldPrice(product: ProductCard) {
  return Boolean(product.oldPrice && product.decimalOldPrice);
}

export function getProductKey(product: ProductCard) {
  return String(product.id ?? product.title);
}